import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Layout } from './components/Layout';
import { Dashboard } from './components/Dashboard/Dashboard';
import { PursuitsPage } from './components/Pursuits/PursuitsPage';
import { AnalysisPage } from './components/Analysis/AnalysisPage';
import { AssetLibraryPage } from './components/AssetLibrary/AssetLibraryPage';
import { DatabasePage } from './components/Database/DatabasePage';
import { TeamPage } from './components/Team/TeamPage';
import { InboxPage } from './components/Inbox/InboxPage';
export function App() {
  return <Layout data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<Dashboard data-id="element-3" />} data-id="element-2" />
        <Route path="/pursuits" element={<PursuitsPage data-id="element-5" />} data-id="element-4" />
        <Route path="/analysis" element={<AnalysisPage data-id="element-7" />} data-id="element-6" />
        <Route path="/asset-library" element={<AssetLibraryPage data-id="element-9" />} data-id="element-8" />
        <Route path="/database" element={<DatabasePage data-id="element-11" />} data-id="element-10" />
        <Route path="/team" element={<TeamPage data-id="element-13" />} data-id="element-12" />
        <Route path="/inbox" element={<InboxPage data-id="element-15" />} data-id="element-14" />
      </Routes>
    </Layout>;
}